import * as XLSX from 'xlsx'
import { Task, TaskLog } from '../types'
import { TeamMember } from '../../../../types'
import dayjs from 'dayjs'
import { getTaskHistoryComplianceMessage, getTasksById, getUserFullName, getUsersById } from './helpers'

export const generateTaskReport = async (tasks: Task[] | null, taskLogs: TaskLog[], users: TeamMember[]) => {
  if (!tasks) return

  const tasksById: Map<number, Task> = getTasksById(tasks)
  const usersById: Map<number, TeamMember> = getUsersById(users)

  const assignmentsByTaskId = new Map(
    tasks.map(task => {
      const assignment = {
        assignedTo: getUserFullName(task.assignedTo, usersById),
        assignedBy: getUserFullName(task.assignedBy, usersById)
      }

      return [task.id, assignment]
    })
  )

  const taskRows = tasks.map(task => {
    const assignments = assignmentsByTaskId.get(task.id)!

    return {
      'Task Name': task.name,
      Description: task.description,
      'Assigned To': assignments.assignedTo,
      'Assigned By': assignments.assignedBy,
    }
  })

  const taskLogRows = taskLogs.map(taskLog => {
    const task = tasksById.get(taskLog.taskId)
    const assignments = assignmentsByTaskId.get(taskLog.taskId)!

    return {
      'Status': getTaskHistoryComplianceMessage(taskLog.status),
      'Task Name': task?.name ?? '',
      Description: task?.description ?? '',
      'Assigned To': assignments.assignedTo,
      'Assigned By': assignments.assignedBy,
      'Due On': dayjs(taskLog.date).format('L'),
      'Updated On': taskLog.updatedDate ? dayjs(taskLog.updatedDate).format('L') : '',
    }
  })

  const wb = XLSX.utils.book_new()

  const ws = XLSX.utils.json_to_sheet(taskRows, { skipHeader: false })
  const ws2 = XLSX.utils.json_to_sheet(taskLogRows, { skipHeader: false })

  XLSX.utils.book_append_sheet(wb, ws, 'Tasks')
  XLSX.utils.book_append_sheet(wb, ws2, 'Task History')

  await XLSX.writeFile(wb, 'Tasks.xlsx')
}
